import { Card, CardContent } from "@/app/components/ui/card";

const features = [
	{
		icon: "/images/claim-landing/shield.svg",
		title: "Build Immediate Trust",
		description: "Verified & Hiring",
	},
	{
		icon: "/images/claim-landing/pen.svg",
		title: "Control Your Story",
		description: "Your brand, Your voice",
	},
	{
		icon: "/images/claim-landing/collaborate.svg",
		title: "Collaborate Securely",
		description: "Only @abclogistics.co.tz emails allowed",
	},
];

export const FeaturesOverviewSection = () => {
	return (
		<section className="flex w-full items-center justify-center p-4 md:p-8 lg:p-20 bg-white">
			<div className="flex-1 max-w-7xl">
				<div className="flex flex-col items-center gap-20">
					<div className="flex flex-col items-center gap-3 w-full -translate-y-4 animate-fade-in opacity-0">
						<h2 className="font-['Plus_Jakarta_Sans',Helvetica] font-bold text-anima-dark-text text-3xl md:text-4xl tracking-normal leading-[62.4px] whitespace-nowrap">
							Start Professional. Scale Later.
						</h2>
					</div>

					<div className="flex flex-col md:flex-row items-start gap-6 w-full">
						{features.map((feature, index) => (
							<Card
								key={index}
								className="flex-1 bg-white rounded-2xl shadow-[0px_2px_24px_rgb(224,241,255,0.5)] border-0 -translate-y-4 animate-fade-in opacity-0"
								style={{
									"--animation-delay": `${(index + 1) * 200}ms`,
								}}
							>
								<CardContent className="flex flex-col items-center gap-6 p-6">
									<div className="inline-flex items-center gap-3 bg-anima-light-blue-bg rounded-lg">
										<div className="inline-flex items-center gap-2.5 p-3 rounded-lg border border-solid border-anima-light-blue-bg">
											<img className="w-8 h-8" alt={feature.title} src={feature.icon} />
										</div>
									</div>

									<div className="inline-flex flex-col items-center gap-4">
										<h3 className="font-['Inter',Helvetica] font-medium text-gray-900 text-xl text-center tracking-normal leading-[normal]">
											{feature.title}
										</h3>

										<div className="flex items-center justify-center gap-2 w-full">
											<img className="w-5 h-5" alt="CheckIcon icon" src="/images/claim-landing/check-icon-2.svg" />
											<p className="font-['Inter',Helvetica] font-normal text-gray-700 text-base text-center tracking-normal leading-6 whitespace-nowrap">
												{feature.description}
											</p>
										</div>
									</div>
								</CardContent>
							</Card>
						))}
					</div>
				</div>
			</div>
		</section>
	);
};
